import { ActivityIndicator } from "@components/ActivityIndicator";
import { Title3 } from "@components/Typography";
import { useTheme } from "@hooks";
import { useStyles } from "./styles";
import { ButtonProps, ButtonSize, ButtonType } from "./types";

export const Button = ({
  title,
  onClick,
  type = ButtonType.Primary,
  size = ButtonSize.Regular,
  loading,
  disabled,
  leftIcon,
  rightIcon,
  buttonStyle: buttonStyleProp,
  textStyle: textStyleProp,
}: ButtonProps) => {
  const { theme } = useTheme();
  const styles = useStyles();

  const disabledStyle = disabled || loading ? styles.disabled : undefined;

  const buttonStyle = (() => {
    if (type === ButtonType.Danger) return styles.buttonDanger;
    if (type === ButtonType.Secondary) return styles.buttonSecondary;
    if (type === ButtonType.Inverse) return styles.buttonInverse;
    return styles.buttonPrimary;
  })();

  const textStyle = [ButtonType.Secondary, ButtonType.Inverse].includes(type)
    ? styles.textSecondary
    : styles.textPrimary;

  const smallStyle = size === ButtonSize.Small ? styles.small : undefined;

  const loadingColor =
    type === ButtonType.Secondary ? theme.loader.secondary : theme.loader.inverse;

  return (
    <div
      onClick={onClick}
      style={{
        ...styles.container,
        ...buttonStyle,
        ...disabledStyle,
        ...buttonStyleProp,
        ...smallStyle,
      }}
    >
      {leftIcon}
      {loading ? (
        <div style={styles.loader}>
          <ActivityIndicator color={loadingColor} />
        </div>
      ) : (
        <Title3 style={{ ...textStyle, ...textStyleProp }}>{title}</Title3>
      )}
      {rightIcon}
    </div>
  );
};
